import { ModulePermissionEnum } from 'app/common/permission-module'
import { Dayjs } from 'dayjs'

export interface IDataTable {
  [key: string]: string
}

export interface IFormFilter {
  locations?: string[]
  stars?: number[]
  keyword?: string
  startDate?: Dayjs | null
  endDate?: Dayjs | null
}

export enum FeedbackSurveyReport23Enum {
  PROFESSIONAL_COMPETENCE = 'Chuyên môn',
  SERVICE_EXPERIENCE = 'Dịch vụ và ứng xử',
  FACILITIES = 'Cơ sở vật chất',
  APPOINTMENT = 'Lịch hẹn',
  PAYMENT = 'Chi phí và thanh toán'
}


export interface IProps {
  module: ModulePermissionEnum
}